import * as actionTypes from "../actionTypes";
import axios from "axios";
import {
  config,
  LOCATION_AUTH,
  FETCH_BRANCH_CONFIG,
} from "../../../config/config";

const fetchTransactionsStart = () => {
  return {
    type: actionTypes.FETCH_TRANSACTIONS_START,
  };
};

const fetchTransactionsSuccess = (transactions, total) => {
  return {
    transactions,
    total,
    type: actionTypes.FETCH_TRANSACTIONS_SUCCESS,
  };
};

const fetchTransactionsFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_TRANSACTIONS_FAILED,
  };
};

export const onFetchTransactions = (page, perPage, userRole, params) => {
  return async (dispatch) => {
    await dispatch(fetchTransactionsStart());
    try {
      let url = `${config.transactions}/transactions?perPage=${perPage}&page=${
        page + 1
      }&sort=-created_at`;
      if (params) {
        url += `&${params}`;
      }
      const transactions = await axios.get(url, {
        headers: {
          "x-user-role": userRole,
        },
      });

      await dispatch(
        fetchTransactionsSuccess(
          transactions.data.data,
          transactions.headers["x-total-count"]
        )
      );
    } catch (e) {
      await dispatch(fetchTransactionsFailed(e));
    }
  };
};
// FILTER
export const onFilterTransactions = () => {
  return {
    type: actionTypes.FILTER_TRANSACTIONS_SUCCESS,
  };
};

const filterTransactionsResetStart = () => {
  return {
    type: actionTypes.FILTER_TRANSACTIONS_RESET,
  };
};

export const onFilterTransactionsReset = (userRole) => {
  return async (dispatch) => {
    await dispatch(filterTransactionsResetStart());
    await dispatch(onFetchTransactions(0, 20, userRole));
  };
};

// TRANSACTION
const fetchTransactionStart = () => {
  return {
    type: actionTypes.FETCH_TRANSACTION_START,
  };
};

const fetchTransactionSuccess = (transaction) => {
  return {
    transaction,
    type: actionTypes.FETCH_TRANSACTION_SUCCESS,
  };
};

const fetchTransactionFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_TRANSACTION_FAILED,
  };
};

export const onFetchTransaction = (id, userRole) => {
  return async (dispatch) => {
    await dispatch(fetchTransactionStart());
    try {
      const transaction = await axios.get(
        `${config.transactions}/transactions/${id}`,
        {
          headers: {
            "x-user-role": userRole,
          },
        }
      );
      setTimeout(() => {
        dispatch(fetchTransactionSuccess(transaction.data.data));
      }, 1000);
    } catch (e) {
      await setTimeout(() => {
        dispatch(fetchTransactionFailed(e));
      }, 1000);
    }
  };
};

const fetchRejectRemarksStart = () => {
  return {
    type: actionTypes.FETCH_REJECT_REMARKS_START,
  };
};

const fetchRejectRemarksSuccess = (remarks) => {
  return {
    remarks,
    type: actionTypes.FETCH_REJECT_REMARKS_SUCCESS,
  };
};

const fetchRejectRemarksFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_REJECT_REMARKS_FAILED,
  };
};

export const onFetchRejectRemarks = () => {
  return async (dispatch) => {
    await dispatch(fetchRejectRemarksStart());

    try {
      const remarks = await axios.get(
        `${config.transactions}/invalid-types?perPage=100&display=true`
      );
      await dispatch(fetchRejectRemarksSuccess(remarks.data.data));
    } catch (e) {
      await dispatch(fetchRejectRemarksFailed());
    }
  };
};

const fetchStoressStart = () => {
  return {
    type: actionTypes.FETCH_STORES_START,
  };
};

const fetchStoresSuccess = (stores) => {
  return {
    stores,
    type: actionTypes.FETCH_STORES_SUCCESS,
  };
};

const fetchStoresFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_STORES_FAILED,
  };
};

export const onFetchStores = (brandId) => {
  return async (dispatch) => {
    await dispatch(fetchStoressStart());

    try {
      const stores = await axios.get(
        `${config.stores}&disabled=0`,
        LOCATION_AUTH
      );
      await dispatch(fetchStoresSuccess(stores.data.data));
    } catch (e) {
      await dispatch(fetchStoresFailed());
    }
  };
};

const approveReceiptStart = () => {
  return {
    type: actionTypes.APPROVE_RECEIPT_START,
  };
};

const approveReceiptSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.APPROVE_RECEIPT_SUCCESS,
  };
};

const approveReceiptFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.APPROVE_RECEIPT_FAILED,
  };
};

export const onApproveReceipt = (transactionId, reqBody) => {
  return async (dispatch) => {
    await dispatch(approveReceiptStart());
    try {
      const approveReceipt = await axios.post(
        `${config.transactions}/transactions/${transactionId}/approve`,
        reqBody
      );

      await dispatch(onFetchTransaction(transactionId));
      await dispatch(approveReceiptSuccess(approveReceipt.data.message));
    } catch (e) {
      if (e.response && e.response.status === 500) {
        await dispatch(approveReceiptFailed("500 (Internal Server Error)"));
      } else {
        await dispatch(approveReceiptFailed(e.response.data.message));
      }
    }
  };
};

const rejectReceiptStart = () => {
  return {
    type: actionTypes.REJECT_RECEIPT_START,
  };
};

const rejectReceiptSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.REJECT_RECEIPT_SUCCESS,
  };
};

const rejectReceiptFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.REJECT_RECEIPT_FAILED,
  };
};

export const onRejectReceipt = (transactionId, reqBody) => {
  return async (dispatch) => {
    await dispatch(rejectReceiptStart());

    try {
      const rejectReceipt = await axios.post(
        `${config.transactions}/transactions/${transactionId}/reject`,
        reqBody
      );
      await dispatch(rejectReceiptSuccess(rejectReceipt.data.message));
      await dispatch(onFetchTransaction(transactionId));
    } catch (e) {
      await dispatch(rejectReceiptFailed(e.response.data.message));
    }
  };
};

const discardTransactionStart = () => {
  return {
    type: actionTypes.DISCARD_TRANSACTION_START,
  };
};

const discardTransactionSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.DISCARD_TRANSACTION_SUCCESS,
  };
};

const discardTransactionFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.DISCARD_TRANSACTION_FAILED,
  };
};

export const onDiscardTransaction = (transactionId, data) => {
  return async (dispatch) => {
    await dispatch(discardTransactionStart());

    try {
      const discard = await axios.post(
        `${config.transactions}/transactions/${transactionId}/discard`,
        data
      );
      await dispatch(onFetchTransaction(transactionId));
      await dispatch(discardTransactionSuccess(discard.data.message));
    } catch (e) {
      await dispatch(discardTransactionFailed(e.response.data.message));
    }
  };
};

const reAnalyzeReceiptStart = () => {
  return {
    type: actionTypes.REANALYZE_RECEIPT_START,
  };
};

const reAnalyzeReceiptSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.REANALYZE_RECEIPT_START,
  };
};

const reAnalyzeReceiptFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.REANALYZE_RECEIPT_FAILED,
  };
};

export const onReAnalyzeReceipt = (transactionId, reqBody) => {
  return async (dispatch) => {
    await dispatch(reAnalyzeReceiptStart());

    try {
      const reAnalyze = await axios.post(
        `${config.transactions}/transactions/${transactionId}/reanalyze`,
        reqBody
      );
      await dispatch(reAnalyzeReceiptSuccess(reAnalyze.data.data));
    } catch (e) {
      await dispatch(reAnalyzeReceiptFailed(e.response.data.message));
    }
  };
};

const fetchBranchesStart = () => {
  return {
    type: actionTypes.FETCH_BRANCHES_START,
  };
};

const fetchBranchesSuccess = (branches) => {
  return {
    branches,
    type: actionTypes.FETCH_BRANCHES_SUCCESS,
  };
};

const fetchBranchesFailed = (err) => {
  return {
    err,
    type: actionTypes.FETCH_BRANCHES_FAILED,
  };
};

export const onFetchBranches = (storeId) => {
  return async (dispatch) => {
    await dispatch(fetchBranchesStart());
    try {
      const branches = await axios.get(
        `${config.branches}&store_id=${storeId}&sort=name&page=${FETCH_BRANCH_CONFIG.page}&perPage=${FETCH_BRANCH_CONFIG.perPage}&&disabled=${FETCH_BRANCH_CONFIG.disabled}`,
        LOCATION_AUTH
      );
      await dispatch(fetchBranchesSuccess(branches.data.data));
    } catch (e) {
      await dispatch(fetchBranchesFailed(e.response.data.message));
    }
  };
};

const addStoreStart = () => {
  return {
    type: actionTypes.ADD_STORE_START,
  };
};

const addStoreSuccess = (response) => {
  return {
    response,
    type: actionTypes.ADD_STORE_SUCCESS,
  };
};

const addStoreFailed = (err) => {
  return {
    err,
    type: actionTypes.ADD_STORE_FAILED,
  };
};

export const onAddStore = (data) => {
  return async (dispatch) => {
    await dispatch(addStoreStart());

    try {
      await axios.post(`${config.branches}`, data);
      await dispatch(addStoreSuccess());
    } catch (e) {
      await dispatch(addStoreFailed());
    }
  };
};

const addBranchStart = () => {
  return {
    type: actionTypes.ADD_BRANCH_START,
  };
};

const addBranchSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.ADD_BRANCH_SUCCESS,
  };
};

const addBranchFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.ADD_BRANCH_FAILED,
  };
};

export const onAddBranch = (data) => {
  return async (dispatch) => {
    await dispatch(addBranchStart());

    try {
      await axios.post(`${config.branches}`, data);
      await dispatch(addBranchSuccess("SUCCESSFUL"));
    } catch (e) {
      await dispatch(addBranchFailed("SOMETHING WENT WRONG"));
    }
  };
};

const editTransactionStart = () => {
  return {
    type: actionTypes.EDIT_TRANSACTION_START,
  };
};

const editTransactionSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.EDIT_TRANSACTION_SUCCESS,
  };
};

const editTransactionFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.EDIT_TRANSACTION_FAILED,
  };
};

export const onEditTransaction = (id, data) => {
  return async (dispatch) => {
    await dispatch(editTransactionStart());

    try {
      const edit = await axios.put(
        `${config.transactions}/transactions/${id}`,
        data
      );
      await dispatch(onFetchTransaction(id));
      await dispatch(editTransactionSuccess(edit.data.message));
    } catch (e) {
      await dispatch(editTransactionFailed(e.response.data.message));
    }
  };
};

const resendCouponStart = () => {
  return {
    type: actionTypes.RESEND_COUPON_START,
  };
};

const resendCouponSuccess = (successMessage) => {
  return {
    successMessage,
    type: actionTypes.RESEND_COUPON_SUCCESS,
  };
};

const resendCouponFailed = (errorMessage) => {
  return {
    errorMessage,
    type: actionTypes.RESEND_COUPON_FAILED,
  };
};

export const onResendCoupon = (data) => {
  return async (dispatch) => {
    await dispatch(resendCouponStart());
    try {
      const resend = await axios.post(`${config.responder}`, data);
      await dispatch(resendCouponSuccess(resend.data.data.message));
    } catch (e) {
      await dispatch(resendCouponFailed(e.response.data.message));
    }
  };
};

export const onFetchTransactionsById = (id, page, perPage, userRole) => {
  return async (dispatch) => {
    await dispatch(fetchTransactionsStart());
    try {
      const transactions = await axios.get(
        `${
          config.transactions
        }/transactions?user=${id}&perPage=${perPage}&page=${page + 1}`,
        {
          headers: {
            "x-user-role": userRole,
          },
        }
      );
      await dispatch(
        fetchTransactionsSuccess(
          transactions.data.data,
          transactions.headers["x-total-count"]
        )
      );
    } catch (e) {
      await dispatch(fetchTransactionsFailed(e));
    }
  };
};

const fraudDetectStart = () => {
  return {
    type: actionTypes.FRAUD_DETECT_START,
  };
};

const fraudDetectSuccess = (response) => {
  return {
    response,
    type: actionTypes.FRAUD_DETECT_SUCCESS,
  };
};

const fraudDetectFailed = (err) => {
  return {
    err,
    type: actionTypes.FRAUD_DETECT_FAILED,
  };
};

export const onFraudDetect = (data) => {
  return async (dispatch) => {
    await dispatch(fraudDetectStart());

    try {
      const detection = await axios.post(`${config.fraud}`, data);
      if (detection.data.data.exists === true) {
        await dispatch(
          fraudDetectFailed("RECEIPT DUPLICATE : FLAG AS INVALID")
        );
      } else {
        await dispatch(fraudDetectSuccess("RECEIPT HAS NO DUPLICATE"));
      }
    } catch (e) {
      await dispatch(fraudDetectFailed(e.response.data.message));
    }
  };
};
